// Imports
import axios from 'axios'

// API Imports
import { API_URL } from '../../../setup/config/env'

// Actions Types
export const MESSAGE_SHOW = 'COMMON_MESSAGE_SHOW'
export const MESSAGE_HIDE = 'COMMON_MESSAGE_HIDE'
export const MODAL_SHOW = 'COMMON_MODAL_SHOW'
export const MODAL_HIDE = 'COMMON_MODAL_HIDE'

export function messageShow(message) {
  return { type: MESSAGE_SHOW, message }
}

export function messageHide() {
  return { type: MESSAGE_HIDE }
}

export function modalShow(message) {
  return { type: MODAL_SHOW, message }
}

export function modalHide() {
  return { type: MODAL_HIDE }
}

export function uploadSingle(data) {
  return axios.post(`${API_URL}/upload`, data, {
    headers: {
      "content-Type": "multipart/form-data",
    },
  });
}

export function upload(data) {
  return dispatch => {
    return axios.post(`${ API_URL }/upload`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export function multipleUpload(data) {
  return dispatch => {
    return axios.post(`${API_URL }/multiple-uploads`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}